export default __webpack_public_path__ + "static/media/CloseCircle Red.3ff01cef.svg";